import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body, Page } from '@ui';
import { scrollToTop } from '@utils/usefulFuncs';
import { DocumentVaultScreen } from '@features/documentVault';
import { DocumentVaultFilterProvider } from '@/contexts/DocumentVaultFilterContext';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const WIDE_WIDTH = 1400;

function DocumentVault() {
  const [pageWidth] = React.useState(WIDE_WIDTH + 'px');

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={pageWidth}>
          <DocumentVaultFilterProvider>
            <DocumentVaultScreen />
          </DocumentVaultFilterProvider>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default DocumentVault;
